<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  @font-face {
      font-family: 'Poppins';
      src: url('./assets/font/Poppins-Bold.ttf');
      font-weight: normal;
      font-style: normal;
  }
  @font-face {
      font-family: 'Roboto-Bold';
      src: url('./assets/font/Roboto-Bold.ttf');
      font-weight: normal;
      font-style: normal;
  }
  @font-face {
      font-family: 'Roboto-Medium';
      src: url('./assets/font/Roboto-Medium.ttf');
      font-weight: normal;
      font-style: normal;
  }
  @font-face {
      font-family: 'Roboto-Regular';
      src: url('./assets/font/Roboto-Regular.ttf');
      font-weight: normal;
      font-style: normal;
  }
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  html,body {
    min-width: 1200px;
    background: #F4F6FC;
    user-select: none;
    font-family: Roboto-Regular;
  }
  .content {
    width: 1180px;
    margin: auto;
  }

  .main {
    padding: 0 40px;
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background-color: #F5F5F5;
  }

  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #bdbdbd;
  }

  ::-webkit-scrollbar-thumb:hover{
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: rgba(0,0,0,0.2);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue